export enum CalculatorTypeEnum {
  PER_PET = 1,
  PER_FOOD
}
